import { createSvgComponent } from "../../icon/createSvgComponent";
import PointStore from "@core/icon/assets/point-store.svg";
export default createSvgComponent(PointStore);